var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Day',{attrs:{"day":_vm.formattedDate}},[_c('div',{attrs:{"slot":"page-content"},slot:"page-content"},[_c('Day2024',{attrs:{"title":_vm.title,"description":_vm.description,"date":_vm.formattedDate}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }